/**
 * Returns true only for native deep link URIs (e.g. spark://, sleepio://).
 * Uses an allowlist to prevent open redirect attacks.
 */
export const isSafeRedirectUri = (uri: string): boolean => {
  try {
    const url = new URL(uri);
    if (url.username || url.password) {
      return false;
    }
    const allowed = new Set(['spark:', 'sleepio:', 'sleep-companion:']);
    return allowed.has(url.protocol);
  } catch {
    return false;
  }
};

/**
 * Builds "?redirectTo=<encoded>" for a safe deep-link URI, else "".
 * Always validates so it is safe to call with raw URL input. Used to thread
 * the deep-link redirect target across activation step navigations.
 */
export const buildRedirectParam = (redirectTo: string | null | undefined): string => {
  if (!redirectTo || !isSafeRedirectUri(redirectTo)) {
    return '';
  }
  return `?redirectTo=${encodeURIComponent(redirectTo)}`;
};

// Route and _p param are the contract the app registers in AppNavigation's linking config (EmailVerification).
const APP_DEEP_LINK_ROUTES: Record<string, string> = {
  sleepio: 'sleepio://emailVerification',
};

export const buildAppDeepLink = (
  product: string | null | undefined,
  currentUrl: string,
): string | null => {
  const route = product ? APP_DEEP_LINK_ROUTES[product] : undefined;
  if (!route) {
    return null;
  }
  return `${route}?_p=${encodeURIComponent(currentUrl)}`;
};
